import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

let api = process.env.API_URL
let prefix = '/posts'

export default {
  get: {
    /**
     * Get posts.
     *
     * @return {Promise}
     */
    getPosts (locale) {
      return Vue.http.get(api + prefix, null, {
        headers: {
          'Accept-Language': locale
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/posts.js